import { useEffect, useState } from "react";
import axios from "axios";
import { Gift, Copy, Check } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ReferralCard = () => {
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    axios.get(`${API}/store/referral/me`).then(({ data }) => setData(data)).catch(() => {});
  }, []);

  if (!data) return null;

  const copy = async () => {
    await navigator.clipboard.writeText(data.code);
    setCopied(true);
    toast.success("Referral code copied!");
    setTimeout(() => setCopied(false), 2000);
  };

  const unusedRewards = (data.rewards || []).filter((r) => !r.used);

  return (
    <div className="bg-gradient-to-br from-emerald-50 to-white rounded-3xl border border-emerald-100 shadow-sm p-8 mb-6" data-testid="referral-card">
      <div className="flex items-center gap-2 mb-3">
        <Gift className="w-5 h-5 text-primary" />
        <h3 className="text-lg font-semibold text-gray-900">Refer Friends, Earn Rewards</h3>
      </div>
      <p className="text-sm text-gray-600 mb-4">
        Friends get <b>{data.friend_pct}% off</b> their first Herb Store order with your code — and you earn a
        one-time <b>{data.reward_pct}% off</b> reward code every time one of them buys.
      </p>
      <div className="flex items-center gap-2 flex-wrap">
        <span className="inline-flex items-center bg-primary text-amber-200 font-bold tracking-widest px-5 py-2.5 rounded-full text-lg" data-testid="referral-code">
          {data.code}
        </span>
        <button onClick={copy} className="inline-flex items-center gap-1.5 border border-gray-200 rounded-full px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50" data-testid="referral-copy-btn">
          {copied ? <Check className="w-4 h-4 text-emerald-600" /> : <Copy className="w-4 h-4" />} Copy
        </button>
        <span className="text-sm text-gray-500" data-testid="referral-count">
          {data.referred_count} friend{data.referred_count === 1 ? "" : "s"} referred
        </span>
      </div>
      {unusedRewards.length > 0 && (
        <div className="mt-4 pt-4 border-t border-emerald-100">
          <p className="text-sm font-semibold text-gray-800 mb-2">Your unused reward codes:</p>
          <div className="flex flex-wrap gap-2">
            {unusedRewards.map((r) => (
              <span key={r.code} className="bg-amber-100 text-amber-800 border border-amber-200 rounded-full px-3 py-1 text-xs font-bold" data-testid={`reward-code-${r.code}`}>
                {r.code} · {r.pct}% off
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
